module.exports = __webpack_public_path__ + "media/images/river_sm-43f3c8e7db3c7119e1a23048d31dd795.png";